var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChipmunk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70%",
    height: "70%",
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 376.71 278.43",
    style: {
      enableBackground: "new 0 0 376.71 278.43"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E85BAF;}\n\t.st1{fill:#720661;}\n\t.st2{fill:#FF9929;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#E22444;}\n\t.st5{fill:#EA3259;}\n\t.st6{fill:#F24472;}\n\t.st7{fill:#F96282;}\n\t.st8{fill:#B2F867;}\n\t.st9{fill:#24514A;}\n\t.st10{fill:#401DAE;}\n\t.st11{fill:#FFFA50;}\n\t.st12{fill:#FFA9C0;}\n\t.st13{fill:none;stroke:#FFFA50;stroke-width:4;stroke-miterlimit:10;}\n\t.st14{fill:#FF0000;}\n\t.st15{fill:none;stroke:#000000;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 92.25,
    cy: 139.22,
    rx: 88.6,
    ry: 136.51
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.2,
    cy: 172.19,
    rx: 47.43,
    ry: 49.64
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 284.22,
    cy: 139.22,
    rx: 88.6,
    ry: 136.51
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 322.16,
    cy: 172.19,
    rx: 47.43,
    ry: 49.64
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipmunk);
export default __webpack_public_path__ + "static/media/chipmunk.5061213c971e2b2e3fa003a96ba987a3.svg";
export { ForwardRef as ReactComponent };